import { Plug } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function IntegrationsPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-foreground">Integrations</h1>
        <p className="text-sm text-foreground-muted">Connect third-party services and tools</p>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4 mb-6">
        <EmptyState
          icon={<Plug className="h-10 w-10" />}
          title="No integrations configured"
          description="Connect external services to enhance your workflow."
        />
      </div>

      {/* Available Integrations */}
      <div className="max-w-2xl space-y-4">
        <h3 className="text-sm font-medium text-foreground">Available Integrations</h3>

        <div className="rounded border border-border bg-background-subtle p-4">
          <div className="flex items-start justify-between">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">OctoPrint</h4>
              <p className="text-xs text-foreground-muted">Monitor and control your 3D printers remotely</p>
            </div>
            <Button size="sm" variant="secondary">Connect</Button>
          </div>
        </div>

        <div className="rounded border border-border bg-background-subtle p-4">
          <div className="flex items-start justify-between">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">Bambu Lab Cloud</h4>
              <p className="text-xs text-foreground-muted">Sync printer status and print history</p>
            </div>
            <Button size="sm" variant="secondary">Connect</Button>
          </div>
        </div>

        <div className="rounded border border-border bg-background-subtle p-4">
          <div className="flex items-start justify-between">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">Slack</h4>
              <p className="text-xs text-foreground-muted">Receive notifications in your Slack workspace</p>
            </div>
            <Button size="sm" variant="secondary">Connect</Button>
          </div>
        </div>

        <div className="rounded border border-border bg-background-subtle p-4">
          <div className="flex items-start justify-between">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">Webhooks</h4>
              <p className="text-xs text-foreground-muted">Send custom events to external services</p>
            </div>
            <Button size="sm" variant="secondary">Configure</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
